export default __webpack_public_path__ + "static/media/bg-masthead-2-480w.9dcd400a.jpg";